import http from "../core/http";
const group = 'diagnostics/timings';

export const getTimingsRequest = async (data) => {
    return await http.post(`${group}/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const markDQRequest = async (data) => {
    return await http.post(`${group}/markDQ`, data).then(res => res.data).catch(http.defaultCatch);
}

export const markFinishedRequest = async (data) => {
    // data: { id, ChipStartTime?, ChipEndTime? }
    return await http.post(`${group}/markFinished`, data).then(res => res.data).catch(http.defaultCatch);
}

export const markTBCRequest = async (data) => {
    return await http.post(`${group}/markTBC`, data).then(res => res.data).catch(http.defaultCatch);
}

export const markDNFRequest = async (data) => {
    return await http.post(`${group}/markDNF`, data).then(res => res.data).catch(http.defaultCatch);
}

export const resetTimingRequest = async (data) => {
    return await http.post(`${group}/reset`, data).then(res => res.data).catch(http.defaultCatch);
}
